import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';

const Education = ({ staggerItem }) => {
  return (
    <section id="education" className="py-20 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-16">
          <span className="underline-3d">Vzdelanie</span>
        </h2>
        
        <div className="relative border-l-2 border-blue-600/30 dark:border-blue-400/20 max-w-4xl mx-auto pl-8 sm:pl-12">
          {portfolioData.education.map((edu, index) => {
            const isFeatured = edu.featured;
            return (
              <motion.div 
                key={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                variants={staggerItem}
                className="mb-16 last:mb-0 relative group"
              >
                {/* Timeline node */}
                <div className={`absolute -left-[41px] sm:-left-[57px] top-0 w-6 h-6 bg-white dark:bg-gray-900 border-4 ${isFeatured ? 'border-amber-500 dark:border-amber-400 shadow-[0_0_10px_rgba(245,158,11,0.5)]' : 'border-blue-600'} rounded-full group-hover:scale-125 transition-transform duration-300`}>
                  {isFeatured && (
                    <span className="absolute inset-0 rounded-full bg-amber-500/30 dark:bg-amber-400/20 animate-ping pointer-events-none" />
                  )}
                </div>
                
                {/* Card container */}
                <div className={`relative p-6 sm:p-8 rounded-2xl border transition-all duration-500 shadow-xl hover:shadow-2xl hover:-translate-y-1 text-left ${
                  isFeatured 
                    ? 'bg-gradient-to-br from-amber-50/30 via-white to-blue-50/10 dark:from-amber-950/15 dark:via-gray-800/40 dark:to-blue-950/5 border-amber-500/30 dark:border-amber-400/20 hover:border-amber-500/60 dark:hover:border-amber-400/40 hover:shadow-amber-500/5' 
                    : 'bg-gray-50/50 dark:bg-gray-800/40 border-gray-200 dark:border-gray-700/50 hover:border-blue-600/50 hover:shadow-blue-600/10'
                }`}>
                  
                  {/* Graduate highlight badge */}
                  {isFeatured && (
                    <div className="absolute -top-3 right-6 flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-amber-500 to-amber-600 dark:from-amber-500/90 dark:to-amber-600/90 text-[10px] sm:text-xs font-mono font-bold text-white rounded-full shadow-md select-none">
                      <Icon icon="mdi:school" className="text-sm animate-bounce" />
                      ČERSTVÝ ABSOLVENT (Ing.)
                    </div>
                  )}

                  <span className="text-blue-500 dark:text-blue-400 font-mono text-sm mb-2 flex items-center gap-2">
                    <Icon icon="mdi:calendar-range" className="text-base" />
                    {edu.period}
                  </span>
                  
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">{edu.school}</h3>
                    {edu.grade && (
                      <span className={`inline-self-start sm:self-auto px-2.5 py-0.5 text-xs font-semibold rounded-md border ${
                        isFeatured 
                          ? 'bg-amber-100/60 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border-amber-300/30' 
                          : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-700'
                      }`}>
                        Prospech: {edu.grade}
                      </span>
                    )}
                  </div>
                  
                  <p className={`text-lg font-medium mb-4 ${isFeatured ? 'text-amber-600 dark:text-amber-400' : 'text-gray-600 dark:text-gray-400'}`}>{edu.degree}</p>
                  
                  {edu.activities && <p className="text-sm text-gray-500 dark:text-gray-400 mb-6 italic">{edu.activities}</p>}
                  
                  <div className="flex flex-wrap gap-2">
                    {edu.skills.map((skill, si) => (
                      <motion.span 
                        key={si}
                        whileHover={{ 
                          backgroundColor: isFeatured ? '#f59e0b' : '#2563eb',
                          color: '#fff',
                          borderColor: isFeatured ? '#f59e0b' : '#2563eb'
                        }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        className={`px-3 py-1 text-xs rounded-full border cursor-default transition-colors ${
                          isFeatured
                            ? 'bg-amber-500/5 dark:bg-amber-400/5 text-amber-700 dark:text-amber-300 border-amber-500/20 dark:border-amber-400/20'
                            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700'
                        }`}
                      >
                        {skill}
                      </motion.span>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
